import React, { useState, useEffect, useContext} from 'react';
import { useHistory } from 'react-router-dom';
import { AuthContext } from '../../shared/context/auth-context';

import { useParams } from 'react-router-dom';
import Card from '../../shared/components/UIElements/Card';
import Button from '../../shared/components/formElements/Button';
import Modal from '../../shared/components/UIElements/Modal';
import { useHttpClient } from '../../shared/hooks/http-hook';
import ErrorModal from '../../shared/components/UIElements/ErrorModal'
import LoadingSpinner from '../../shared/components/UIElements/LoadingSpinner';
import './CustomerInfo.css';
import Avatar from '../../shared/components/UIElements/Avatar';
import FloatingButton from '../../shared/components/UIElements/FloatingButton';


const CustomerInfo = () => {
  const auth = useContext(AuthContext);
  const history = useHistory();
  const [loadedCustomer, setLoadedCustomer] = useState({
    name: "",
    lastname: "",
    phone: "",
    address: ""
  });
  const { isLoading, error, sendRequest, clearError } = useHttpClient();

  const customerID = useParams().customerId;
  
  useEffect(() => {
    const fetchCustomer = async() => {
      try{
        const responseData = await sendRequest(process.env.REACT_APP_BACKEND_URL+`/customers/${customerID}`,
        "GET",
        null,
        {Authorization: 'Bearer '+ auth.token});
        setLoadedCustomer(responseData.customer)
      } catch (err) {}
    };
    fetchCustomer();
  }, [sendRequest, customerID, auth.token]);

  const [showConfirmModal, setShowConfirmModal] = useState(false);

  const showDeleteWarningHandler = () => {
    setShowConfirmModal(true);
  };

  const cancelDeleteHandler = () => {
    setShowConfirmModal(false);
  };

  const confirmDeleteHandler = async () => {
    setShowConfirmModal(false);
    try {
      await sendRequest(
        process.env.REACT_APP_BACKEND_URL+`/customers/${customerID}`,
        'DELETE',
         null,
        {Authorization: 'Bearer '+ auth.token}
      );
      history.push('/customers');
    } catch (err) {}
  };

  return (
    <React.Fragment>
      <ErrorModal error={error} onClear={clearError} />
      {isLoading && (
        <div className="center">
          <LoadingSpinner />
        </div>
      )}
      <Modal
        show={showConfirmModal}
        onCancel={cancelDeleteHandler}
        header="Are you sure?"
        footerClass="customer-item__modal-actions"
        footer={
          <React.Fragment>
            <Button inverse onClick={cancelDeleteHandler}>
              CANCEL
            </Button>
            <Button danger onClick={confirmDeleteHandler}>
              DELETE
            </Button>
          </React.Fragment>
        }
      >
        <p>
          Do you want to proceed and delete this customer? Please note that it
          can't be undone thereafter.
        </p>
      </Modal>
      {!isLoading && loadedCustomer &&
      <li className="customer-list">
        <Card className="customer-item__content">
          <div className="customer-avatar">
            {/* we need to add this avatar to the asset folder */}
            <Avatar image="https://static.vecteezy.com/system/resources/previews/004/773/704/original/a-girl-s-face-with-a-beautiful-smile-a-female-avatar-for-a-website-and-social-network-vector.jpg"/>
          </div>    
          <div className="customer-item__info">
            <h2>
              {loadedCustomer.name} {loadedCustomer.lastname}
            </h2>
            <h3>
              ({String(loadedCustomer.phone).slice(0, 3)})-
              {String(loadedCustomer.phone).slice(3, 6)}-
              {String(loadedCustomer.phone).slice(6, 10)} 
            </h3>
            <h3>{loadedCustomer && loadedCustomer.address}</h3>
          </div>
          <div className="customer-item__actions">
            <Button inverse to="/customers">
              BACK
            </Button>
            <Button to={`/customers/${customerID}/edit`}>EDIT</Button>
            <Button danger onClick={showDeleteWarningHandler}>
                DELETE
            </Button>    
          </div>
        </Card>
      </li>}
     <FloatingButton icon={"back"} />
    </React.Fragment>
  );
};

export default CustomerInfo;
